// extracted by mini-css-extract-plugin
export default {"faqDiv":"faq_faqDiv__rJ3ja","faqDiv_content":"faq_faqDiv_content__EQPTd"};